/* Tourance Editorial: collapse PDP reviews to 1 with a Show all toggle. */
(function () {
  var VISIBLE = 1;

  function init() {
    var panel = document.querySelector('[data-tab-panel="reviews"]');
    if (!panel) return;
    var cards = Array.prototype.slice.call(panel.querySelectorAll('.review-card'));
    if (cards.length <= VISIBLE) return;

    var style = document.createElement('style');
    style.textContent =
      '.reviews-toggle{display:block;width:100%;margin-top:16px;padding:13px 18px;background:none;' +
      'border:1px solid var(--hairline,#E4DDD0);border-radius:10px;font:inherit;font-size:13px;' +
      'letter-spacing:0.08em;color:var(--ink,#1A1816);cursor:pointer;transition:border-color .2s ease,background .2s ease;}' +
      '.reviews-toggle:hover{border-color:var(--ink,#1A1816);background:var(--bone,#F4EFE8);}';
    document.head.appendChild(style);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'reviews-toggle';
    var expanded = false;

    function apply() {
      cards.forEach(function (card, i) {
        card.style.display = expanded || i < VISIBLE ? '' : 'none';
      });
      btn.textContent = expanded ? 'Show fewer reviews' : 'Show all ' + cards.length + ' reviews';
      btn.setAttribute('aria-expanded', String(expanded));
    }

    btn.addEventListener('click', function () {
      expanded = !expanded;
      apply();
      if (!expanded) {
        var first = cards[0];
        if (first && first.scrollIntoView) first.scrollIntoView({ block: 'nearest' });
      }
    });

    panel.appendChild(btn);
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
